export default __webpack_public_path__ + "static/media/adeojo.fa9d1d71.webp";